import { useEffect, useState } from "react";
import { usePlay } from "@/providers/play-provider";
import { PlayHeader } from "@/pages/subs/play/play-header";
import { GameMetadata, getGameMetadata } from "../common/game-registry";
import { LobbyView } from "./lobby-view";
import { RoomView } from "./room-view";
import { GameView } from "./game-view";

export const OnlineView = ({
  games,
  goToSelectMode,
}: {
  games: GameMetadata[];
  goToSelectMode: () => void;
}) => {
  const { currentRoom } = usePlay();
  const [gameMetadata, setGameMetadata] = useState<GameMetadata | null>(null);

  useEffect(() => {
    if (currentRoom) {
      const metadata = getGameMetadata(currentRoom.gameType);
      setGameMetadata(metadata || null);
    }
  }, [currentRoom?.gameType]);

  if (currentRoom?.status === "playing" && gameMetadata) {
    return <GameView game={gameMetadata} />;
  }

  return (
    <div className="w-full h-full flex flex-col">
      <PlayHeader game={gameMetadata} title="🌐 온라인 게임" onClickBack={() => goToSelectMode()} />
      <div className="flex-1">
        {currentRoom ? <RoomView /> : <LobbyView games={games} />}
      </div>
    </div>
  );
};
